module.exports = "<div ng-transclude></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpComponentsList/adpComponentsList.html
// module id = 477
// module chunks = 0